/**
 * DEV-2339 — borderless text-link button used inside the account-overview
 * coachmark tooltip (a dark surface). Two tones from Figma: `primary`
 * (brand-300 #b7b2ff — the "Explore" action) and `secondary` (brand-50
 * #eeedfe — "Got it"). Both shift to white on hover.
 *
 * Local to this folder because no DS/project component covers a colored text
 * link on a dark surface (DS link variants are navy or plain white), and the
 * coachmark uses it twice.
 */
export const CoachmarkTextButton = ({
	label,
	tone = 'secondary',
	disabled = false,
	onClick
}: {
	label: string
	tone?: 'primary' | 'secondary'
	disabled?: boolean
	onClick?: () => void
}) => (
	<button
		type="button"
		disabled={disabled}
		onClick={onClick}
		className={`text-[12px] font-normal leading-[16px] hover:text-white ${
			tone === 'primary' ? 'text-[#b7b2ff]' : 'text-[#eeedfe]'
		}`}
	>
		{label}
	</button>
)
